import { Component } from "@angular/core";

@Component({
  selector: "shared-header-swiper",
  templateUrl: "./swiper.component.html",
  styleUrls: ["./swiper.component.scss"],
})
export class SwiperComponent {}
